<template>
  <div>
    <add-address-modal :customer="customer" ref="addAddressModal" @reFetchCustomer="$emit('reFetchCustomer')"/>

    <template v-if="addresses.length">
      <q-field :error="errors.has('address')" :error-label="errors.first('address')">
        <q-select
          :value="value"
          @input="update"
          ref="address"
          :display-value="value ? value.address_line_1 : null"
          :float-label="$t('address')"
          :options="addresses"
          name="address"
          separator
          hide-underline
        />
      </q-field>
    </template>

    <template v-if="!addresses.length && errors.has('address')">
      <p class="text-negative">{{ $t('address_required') }}</p>
    </template>

    <q-btn v-if="!addresses.length" @click="handleAddAddress" class="q-mt-md add-address-btn">{{ $t('add_address') }}</q-btn>
  </div>
</template>

<script>
  import AddAddressModal from 'components/Customers/AddAddressModal.vue'

  export default {
    inject: ['$validator'],

    props: {
      customer: {
        required: true,
        type: Object
      },

      value: {
        type: Object
      }
    },

    computed: {
      hasAddresses () {
        return this.customer.hasOwnProperty('addresses')
      },

      addresses () {
        return this.hasAddresses
          ? this.customer.addresses.data.map(address => ({
            icon: this.customer.default_address_id === address.id ? 'star' : null,
            label: address.address_line_1,
            sublabel: `${address.locality}, ${address.postal_code} - ${address.country_code}`,
            value: address
          }))
          : []
      }
    },

    methods: {
      handleAddAddress () {
        this.$refs.addAddressModal.open()
      },

      update (address) {
        this.$emit('input', address)
      },

      handleCustomerChanged (customer) {
        let address = null
        if (customer && customer.addresses) {
          // Check if the customer has a default address, if not just use the first one
          address = !customer.default_address_id ? customer.addresses.data[0]
          : customer.addresses.data.find(address => address.id === customer.default_address_id)
        }

        this.$emit('input', address)
      }
    },

    created () {
      this.handleCustomerChanged(this.customer)
    },

    watch: {
      customer: {
        handler: function (customer) {
          this.handleCustomerChanged(customer)
        },
        deep: true
      }
    },

    components: {
      AddAddressModal
    }
  }
</script>
